import React, { useEffect, useState } from 'react'
import { Trans, useTranslation, WithTranslation } from 'react-i18next'
import { FiChevronDown, FiChevronRight, FiDollarSign } from 'react-icons/fi'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import {
  Label,
  MenuElement,
  MenuList,
} from '../../../../../components/Template/Sidebar'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'
import { IStore } from '../../../../../reducers'
import { PriceConfigurationActions } from '../../../../../reducers/price/actionNames'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import {
  getUserId,
  getUserPriceGroup,
} from '../../../../../reducers/userAccount/selectors/userAccount'
import useIsScope from '../../../../../hooks/useIsScope'
import { PermissionScope } from '../../../../Employees'
import {
  isInPlanScope,
  isInPlanScopeRedirect,
  PlansScope,
  useLicensePlansScope,
} from '../index'
import Flex from 'typescript-styled-flex'
import SmartLink from '../../../../../components/Template/Sidebar/SmartLink'
import UpgradePremiumBlockScreenModal from '../../../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'
import { useMediaQuery, useTheme } from '@material-ui/core'
import { PopoveredIcon2 } from '../../../../../components/PopoveredIcon/PopoveredIcon'

function Pricing({
  isSidebarOpen,
  className,
  size = 1,
}: IPricingProps & WithTranslation & IWithSize) {
  const [isOpen, toggleOpen] = React.useState(false)
  const dispatch = useDispatch()
  const config = useSelector((state: IStore) => state.price.config)
  // const user = useSelector(getUserId)
  const { t } = useTranslation()
  const userId = useSelector(getUserId)
  const userPriceGroup = useSelector(getUserPriceGroup)
  const planScope = useLicensePlansScope()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const [isModalOpened, setIsModalOpened] = useState(false)
  // const trackClick = () => {
  //   Mixpanel.people.increment(userId, 'Payments Methods Menu Opened', 1)
  //   Mixpanel.track('Payments Methods Menu Item Used', {})
  // }

  const handleLinkClick = (event, userPlanScope) => {
    if (
      userPlanScope &&
      isMobile &&
      isInPlanScope(planScope, userPlanScope, userPriceGroup) === true
    ) {
      event.preventDefault()
      event.stopPropagation()
      setIsModalOpened(true)
    } else if (
      userPlanScope &&
      !isMobile &&
      isInPlanScope(planScope, userPlanScope, userPriceGroup) === true
    ) {
      event.preventDefault()
      event.stopPropagation()
      handlePopoverOpen(event)
    }
  }

  // const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
  //   const target = event.currentTarget
  //   if (isSidebarOpen) {
  //     setTimeout(() => {
  //       setPopoverAnchor(target)
  //     }, 50)
  //   }
  // }

  const handlePopoverOpen = event => {
    event.preventDefault()
    event.stopPropagation()
    setPopoverAnchor(event.currentTarget)
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }

  const trackClick3 = () => {
    Mixpanel.people.increment(userId, 'Additional Services Menu Opened', 1)
    Mixpanel.track('Additional Services Menu Item Used', {})
  }

  const trackClick2 = () => {
    Mixpanel.people.increment(userId, 'Prepayment Menu Opened', 1)
    Mixpanel.track('Prepayment Menu Item Used', {})
  }

  function toggleIsOpen() {
    toggleOpen(!isOpen)
    if (!isOpen) {
      Mixpanel.track('Price List Menu Item Used', [])
      Mixpanel.people.increment(userId, 'Price List Menu Item Used', 1)
    }
  }

  function mixPanelPush(eventName) {
    Mixpanel.track(eventName, [])
    Mixpanel.people.increment(userId, eventName, 1)
    return
  }

  useEffect(() => {
    if (isEmpty(config)) {
      dispatch({ type: PriceConfigurationActions.RequestForConfiguration })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEmpty(config)])

  const scopes = useIsScope({
    prices: [PermissionScope.SCOPE_CAN_USE_PRICING_AND_RESTRICTIONS],
    config: [PermissionScope.SCOPE_CAN_USE_PRICING_SETTINGS],
  })

  if (isEmpty(config)) {
    return (
      <MenuElement
        size={size}
        alignCenter={true}
        primary={true}
        column={true}
        open={isOpen}
        active={isOpen}
      >
        <MenuElement
          size={size}
          as={'div'}
          alignCenter={true}
          open={isOpen}
          onClick={toggleIsOpen}
          className={`${className}-button-expand`}
          nested={true}
        >
          <b>
            <FiDollarSign size={16 * size} />
          </b>
          <Label primary={true} size={size} className={`${className}-label`}>
            <Trans i18nKey={'menu_pricing'}>Pricing</Trans>
          </Label>
          <b>
            {isSidebarOpen &&
              (isOpen ? (
                <FiChevronDown size={14 * size} />
              ) : (
                <FiChevronRight size={14 * size} />
              ))}
          </b>
        </MenuElement>
      </MenuElement>
    )
  }

  return (
    <>
      <MenuElement
        size={size}
        alignCenter={true}
        primary={true}
        column={true}
        open={isOpen}
        active={isOpen}
      >
        <MenuElement
          size={size}
          as={'div'}
          alignCenter={true}
          open={isOpen}
          onClick={toggleIsOpen}
          className={`${className}-button-expand`}
          nested={true}
        >
          <b>
            <FiDollarSign size={16 * size} />
          </b>
          <Label primary={true} size={size} className={`${className}-label`}>
            <Trans i18nKey={'menu_pricing'}>Pricing</Trans>
          </Label>
          <b>
            {isSidebarOpen &&
              (isOpen ? (
                <FiChevronDown size={14 * size} />
              ) : (
                <FiChevronRight size={14 * size} />
              ))}
          </b>
        </MenuElement>
        {isSidebarOpen && (
          <MenuList
            size={size}
            nested={true}
            style={{ maxHeight: 'var(--full)' }}
          >
            {scopes.prices && (
              <SmartLink
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.SetPrices,
                  !config.displayed &&
                    localStorage.getItem(userId + '+PriceConfigFirstTime') !==
                      '1'
                    ? '/price/configuration'
                    : '/price/set',
                  userPriceGroup,
                )}
                activeClassName={'active'}
                nested={true}
                onClick={e => {
                  handleLinkClick(e, PlansScope.SetPrices)
                  mixPanelPush('New Price Set Prices Menu Item Used')
                }}
              >
                <MenuElement
                  size={size}
                  alignCenter={true}
                >
                  <Flex alignCenter full>
                    {t('BBO_1500_set_prices')}
                    {isInPlanScope(
                      planScope,
                      PlansScope.SetPrices,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}

            {scopes.config && (
              <SmartLink
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.PricingConfig,
                  '/price/configuration',
                  userPriceGroup,
                )}
                activeClassName={'active'}
                nested={true}
                onClick={e => {
                  handleLinkClick(e, PlansScope.PricingConfig)
                  mixPanelPush('New Price Configuration Menu Item Used')
                }}
              >
                <MenuElement
                  size={size}
                  alignCenter={true}
                >
                  <Flex alignCenter full>
                    {t('configuration')}
                    {isInPlanScope(
                      planScope,
                      PlansScope.PricingConfig,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}
            {/*{pricelistVersion === '1' && scopes.config && (*/}
            {/*  <Link*/}
            {/*    size={size}*/}
            {/*    to={'/price/edit'}*/}
            {/*    activeClassName={'active'}*/}
            {/*    nested={true}*/}
            {/*    className={`${className}-item-0-label`}*/}
            {/*  >*/}
            {/*    <MenuElement*/}
            {/*      size={size}*/}
            {/*      alignCenter={true}*/}
            {/*      className={`${className}-item-0-button`}*/}
            {/*    >*/}
            {/*      <Trans i18nKey={'edit'}>Edytuj</Trans>*/}
            {/*    </MenuElement>*/}
            {/*  </Link>*/}
            {/*)}*/}
            {/*{pricelistVersion === '2' && user < 120060 && scopes.config && (*/}
            {/*  <Link*/}
            {/*    size={size}*/}
            {/*    to={'/price/edit'}*/}
            {/*    activeClassName={'active'}*/}
            {/*    nested={true}*/}
            {/*    className={`${className}-item-0-label`}*/}
            {/*    onClick={() => mixPanelPush('Show Old Price List Menu Item Used')}*/}
            {/*  >*/}
            {/*    <MenuElement*/}
            {/*      size={size}*/}
            {/*      alignCenter={true}*/}
            {/*      className={`${className}-item-0-button`}*/}
            {/*    >*/}
            {/*      <Trans i18nKey={'BBO_2434_see_old_pricelist'}>*/}
            {/*        Old pricelist*/}
            {/*      </Trans>*/}
            {/*      <Badge size={size} error={true}>*/}
            {/*        OLD*/}
            {/*      </Badge>*/}
            {/*    </MenuElement>*/}
            {/*  </Link>*/}
            {/*)}*/}

            {scopes.config && (
              <SmartLink
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.Prepayment,
                  '/price/prepayment',
                  userPriceGroup,
                )}
                onClick={e => {
                  trackClick2()
                  handleLinkClick(e, PlansScope.Prepayment)
                }}
                activeClassName={'active'}
                nested={true}
                className={`${className}-item-1-label`}
              >
                <MenuElement
                  size={size}
                  alignCenter={true}
                  className={`${className}-item-1-button`}
                >
                  <Flex alignCenter full>
                    {t('BKO_902_menu_prepayment')}
                    {isInPlanScope(
                      planScope,
                      PlansScope.Prepayment,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}
            {/*<Link*/}
            {/*  onClick={trackClick}*/}
            {/*  size={size}*/}
            {/*  to={'/price/method'}*/}
            {/*  activeClassName={'active'}*/}
            {/*  nested={true}*/}
            {/*  className={`${className}-item-1-label`}*/}
            {/*>*/}
            {/*  <MenuElement*/}
            {/*    size={size}*/}
            {/*    alignCenter={true}*/}
            {/*    className={`${className}-item-1-button`}*/}
            {/*  >*/}
            {/*    <Trans i18nKey={'BKO_902_menu_payment_method'}>*/}
            {/*      Metody rezerwacji*/}
            {/*    </Trans>*/}
            {/*  </MenuElement>*/}
            {/*</Link>*/}
            {scopes.config && (
              <SmartLink
                size={size}
                to={isInPlanScopeRedirect(
                  planScope,
                  PlansScope.AdditionalServices,
                  '/price/additional',
                  userPriceGroup,
                )}
                onClick={e => {
                  trackClick3()
                  handleLinkClick(e, PlansScope.AdditionalServices)
                }}
                activeClassName={'active'}
                nested={true}
                className={`${className}-item-1-label`}
              >
                <MenuElement
                  size={size}
                  alignCenter={true}
                  className={`${className}-item-1-button`}
                >
                  <Flex alignCenter full>
                    <Trans i18nKey={'z2736_label_additional_services'}>
                      Usługi dodatkowe
                    </Trans>
                    {isInPlanScope(
                      planScope,
                      PlansScope.AdditionalServices,
                      userPriceGroup,
                    ) && (
                      <Flex
                        style={{ marginLeft: 'auto' }}
                        alignCenter
                        justifyEnd
                      >
                        <PopoveredIcon2 />
                      </Flex>
                    )}
                  </Flex>
                </MenuElement>
              </SmartLink>
            )}
          </MenuList>
        )}
      </MenuElement>
      <Flex
        style={{ marginLeft: 'auto' }}
        alignCenter
        justifyEnd
      >
        <PopoveredIcon2
          withIcon={false}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          anchorEl={popoverAnchor}
          onOpen={handlePopoverOpen}
          onClose={handlePopoverClose}
        />
      </Flex>
      <UpgradePremiumBlockScreenModal
        open={isModalOpened}
        close={() => setIsModalOpened(false)}
      />
    </>
  )
}

export default Pricing

export interface IPricingProps {
  isSidebarOpen: boolean
  className?: string
}
